import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { Close as CloseIcon, InsertDriveFile as FileIcon } from '@mui/icons-material';

const FilePreview = ({ file, onRemove }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        p: 1.5,
        mt: 1,
        backgroundColor: '#f8fafc',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <FileIcon color="primary" />
        <Typography variant="body2">{file.name}</Typography>
      </Box>
      <IconButton
        size="small"
        onClick={onRemove}
        sx={{ color: 'error.main' }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

export default FilePreview;